import Modal from "@/components/Common/Modal";
import useManageCredits from "@/hooks/useManageCredits";
import ManageCreditsContent from "@/pages/plans/creditSystem/ManageCreditsContent";
import {manageCreditsModalAtom} from "@/store/jotaiAtoms";
import {useAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const ManageCreditsModal: FC = () => {
  const {t} = useTranslation("common");
  const [modalState, setModalState] = useAtom(manageCreditsModalAtom);

  const credits = modalState.credits ?? 0;
  const influencerFees = modalState.influencerFees ?? {};
  const isAddMode = modalState.type === "add";

  const handleClose = () =>
    setModalState(draft => {
      draft.isOpen = false;
    });

  const manageCredits = useManageCredits({
    credits,
    influencerFees,
    onConfirm: modalState.onConfirm,
    onSuccess: handleClose,
    type: modalState.type,
  });

  return (
    <Modal
      backgroundClassName="max-w-md"
      confirmButtonClassName="flex-2"
      confirmButtonText={isAddMode ? t("add_credits") : t("delete_credits")}
      confirmButtonTextClassName="md:text-base"
      isConfirmDisabled={manageCredits.isConfirmDisabled}
      modalTitle={isAddMode ? t("add_credits_to_account") : t("remove_credits_from_account")}
      onClose={handleClose}
      onConfirm={manageCredits.confirm}
      shouldCloseOnConfirm={false}>
      <ManageCreditsContent credits={credits} influencerFees={influencerFees} manageCredits={manageCredits} />
    </Modal>
  );
};

export default ManageCreditsModal;
